/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Email_ErrorInputs */

const en_admin_create_email_error = /** @type {(inputs: Admin_Create_Email_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error checking email.`)
};

const de_admin_create_email_error = /** @type {(inputs: Admin_Create_Email_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Prüfen der E-Mail.`)
};

/**
* | output |
* | --- |
* | "Error checking email." |
*
* @param {Admin_Create_Email_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_email_error = /** @type {((inputs?: Admin_Create_Email_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Email_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_email_error(inputs)
	return en_admin_create_email_error(inputs)
});